export default {
  productOptions: [
    "Industrial Rubber Parts",
    "Automotive Rubber Parts",
    "Anti-vibration Rubber",
    "Packing & Gaskets",
    "Compression Molded Products",
    "Rubber Molded Products",
    "Custom Made Products",
    "Other (enter manually)",
  ],
  page: {
    title: "Request a Quote",
    bannerSubtitle: "Send us your drawings and requirements and we will provide an optimal quote quickly",
    submittedSubtitle: "Your quote request has been received",
    submittedTitle: "Quote Request Received",
    submittedDesc: "Our engineer will review your drawing and requirements and email a quotation within 2-3 business days. For urgent matters, please contact us by phone.",
    viewProducts: "View Products",
    viewTech: "View Technical Data",
    guideTitle: "Quotation Guide",
    guideDesc: "For accurate pricing, please send the information below for faster consultation.",
    requiredInfoTitle: "Information Required for Quotation",
    requiredInfo: [
      "Product drawing or sketch (PDF, DWG, JPG)",
      "Required quantity (estimated monthly usage)",
      "Application environment (temperature, contact fluid, pressure, etc.)",
      "Required properties (hardness, tensile strength, heat resistance, etc.)",
      "Desired delivery date",
    ],
    processTitle: "Quotation Process",
    process: [
      { step: 1, title: "Inquiry Received", desc: "Received via phone, email, or the quote board" },
      { step: 2, title: "Drawing Review", desc: "Engineer reviews drawings/specs and recommends materials" },
      { step: 3, title: "Quote Sent", desc: "Quote emailed within 2-3 business days" },
      { step: 4, title: "Consultation & Adjustment", desc: "Quantity, delivery, and spec negotiation with final quote confirmation" },
    ],
    telInquiry: "Phone Inquiry",
    emailInquiry: "Email Inquiry",
    onlineTitle: "Online Quote Request",
    onlineDesc: "Fill out the form below and our engineer will review it and send you a quotation. Fields marked * are required.",
    form: {
      company: "Company",
      companyPlaceholder: "Enter your company name",
      name: "Contact Person",
      namePlaceholder: "Enter the contact person's name",
      phone: "Phone",
      phonePlaceholder: "Enter your phone number",
      email: "Email",
      emailPlaceholder: "Enter your email",
      productCategory: "Product Category",
      productCategoryPlaceholder: "Select a product category",
      productName: "Product Name / Part No.",
      productNamePlaceholder: "Enter the product name or part number",
      quantity: "Required Quantity",
      quantityPlaceholder: "e.g. 10,000 units/month / 500 units initial",
      deadline: "Desired Delivery",
      deadlinePlaceholder: "e.g. end of August 2025 / ASAP",
      requirements: "Requirements",
      requirementsPlaceholder: "Please describe the application environment, required properties (hardness, heat resistance, oil resistance, etc.), and other details.",
      maxLengthHint: "Up to 500 characters.",
      drawingFile: "Attach Drawing File",
      drawingFileHint: "PDF, DWG, DXF, JPG, PNG files accepted (up to 10MB)",
      consent: "I agree to the collection and use of my personal information. The collected information is used solely for quote processing and is stored securely in accordance with relevant laws.",
      submit: "Request a Quote",
      submitting: "Submitting...",
    },
  },
};